import React from "react";
import ButtonBasic from "./ButtonBasic";
import { Spinner } from "react-bootstrap";

export default function ButtonSpinner({ id, cypressid, label, ...props }) {
  return (
    <ButtonBasic id={id} cypressid={cypressid} disabled aria-busy="true" {...props}>
      {label}...{" "}
      <output>
        <Spinner animation='border' variant='light' size='sm' style={{ marginLeft: "0.7rem" }}>
          <span className='sr-only'>Processing...</span>
        </Spinner>
      </output>
    </ButtonBasic>
  );
}

ButtonSpinner.defaultProps = {
  theme: "deq-primary",
  label: "Processing",
  cypressid: "processing"
};
